import { FC, useState } from "react";
import { SquareTab } from ".";

// styles
import styles from "./squareTabContainer.module.scss";

type TSquareTabContainerProps = {
    extraClassNameTabContainer?: string,
    extraClassNameTabContentContainer?: string,
    extraClassNameMainContainer?: string,
    extraClassNameTab?: string,
    extraClassNameActiveTab?: string,
    parentallyIssuedSelectedTabIndex?: number,
    setParentallyIssuedSelectedTabIndex?: (index: number) => void
    children: (JSX.Element | null)[];
};

export const SquareTabContainer: FC<TSquareTabContainerProps> = (
        {extraClassNameTabContainer, extraClassNameTabContentContainer, extraClassNameMainContainer, children, parentallyIssuedSelectedTabIndex,
            extraClassNameTab, extraClassNameActiveTab, setParentallyIssuedSelectedTabIndex} : TSquareTabContainerProps) => { 
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    if (!Array.isArray(children)) children = [children];

    const getTabContainerClassName = (): string => {
        const classNameList = [styles.squareTabContainer];
        if(extraClassNameTabContainer) classNameList.push(extraClassNameTabContainer);
        const className = classNameList.join(" ");                
        return className;
    };

    const getTabContentContainerClassName = (): string => {
        const classNameList = [styles.squareTabContainerContent];
        if(extraClassNameTabContentContainer) classNameList.push(extraClassNameTabContentContainer);
        const className = classNameList.join(" ");                
        return className;
    };

    const getMainContainerClassName = (): string => {
        const classNameList = [styles.mainContentContainer];
        if(extraClassNameMainContainer) classNameList.push(extraClassNameMainContainer);
        const className = classNameList.join(" ");                
        return className;
    };

    const currentIndex = parentallyIssuedSelectedTabIndex ? parentallyIssuedSelectedTabIndex : selectedTabIndex;
    const setCurrentIndexFunction = setParentallyIssuedSelectedTabIndex ? setParentallyIssuedSelectedTabIndex : setSelectedTabIndex;
    
    return (
        <div className={getMainContainerClassName()}>
            <div className={getTabContainerClassName()}>
                {children.map((item, index) => {
                    if(item === null) return null;
                    return (
                        <SquareTab key={index} isActive={index === currentIndex} title={item.props.title} 
                            extraClassName={extraClassNameTab} extraClassNameActiveTab={extraClassNameActiveTab}
                            setSelectedTabIndex={() => { setCurrentIndexFunction(index); }} />
                    );
                })}
            </div>
            <div className={getTabContentContainerClassName()}>
                {children[currentIndex]}
            </div>
        </div>
    );
};